import { gql } from "graphql-request"

const elrond = {
    name: 'elrond',
    title: 'The MultiversX (Elrond) Mainnet',
    currency: 'EGLD',
    check: true,
    regexp: '([\\W]|^)(erd1[a-zA-HJ-NP-Z0-9]{40,70})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        elrond(network: elrond) {
            ins: transfers(txReceiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            outs: transfers(txSender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
        }
    }`,
    checkAddress:
        'erd10c0pfr5g5c7hd0arnechczhgetwad8ah6896gum0f8pw2lzdsfcqsx7e2z',
}
export { elrond }
